import { useTranslation } from 'react-i18next'

import { PlaceFeatureKey } from '../../features/places-features.constants'
import { hasFeatureDescription } from '../../features/places-features.descriptions'
import * as S from './place-feature-collapsible-group.styled'

export const usePlaceFeatureTooltip = (featureKey: PlaceFeatureKey, hint?: string) => {
  const { t } = useTranslation(['organisation'])

  const hasDescription = hasFeatureDescription(featureKey)

  if (!hasDescription && !hint) return undefined

  return (
    <>
      {hasDescription && t(`organisation:places.features.descriptions.${featureKey}`)}
      {hint && <S.TooltipHint>{hint}</S.TooltipHint>}
    </>
  )
}
